import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult } from '@tanstack/react-query'
import type { IOkrs } from '~/types/okr'

import { getOkrsData } from '~/api/home'

////////// KEYS //////////
export const okrsKeys = {
  all: ['okrs'] as const,
  list: () => [...okrsKeys.all, 'list'] as const,
}

////////// QUERIES //////////
export const useOkrsListQuery = (): UseQueryResult<IOkrs, unknown> => {
  return useQuery({
    queryFn: () => getOkrsData(),
    queryKey: okrsKeys.list(),
  })
}
